<template>
    <div>
        <b-card no-body
                border-variant="ep"
                :header="form.id ? 'Lead doorzetten naar EasyParty' : 'Lead aanmaken'"
                header-bg-variant="ep"
                header-text-variant="white"
                class="mb-3 timeline-box">
            <b-list-group flush>
                <b-list-group-item>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="company">Organisatie: *</label>
                                <div :class="isInvalid('ev-organisation')">
                                    <afas-company-input :form="form" ref="afasCompanyInput" v-model="field.organisation"></afas-company-input>
                                    <div v-if="isInvalid('ev-organisation')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-organisation'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="contact">Contactpersoon: *</label>
                                <div :class="isInvalid('ev-contact')">
                                    <afas-contact-input :form="form" ref="afasContactInput" v-model="field.contact" :organisation="field.organisation"></afas-contact-input>
                                    <div v-if="isInvalid('ev-contact')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-contact'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="contactInfo">Achtergrondinformatie:</label>
                                <b-form-textarea id="contactInfo" v-model="field.contactInfo" placeholder="Optioneel..." rows="4" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('ev-contactInfo')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['ev-contactInfo'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="ev-location">Locatie: *</label>
                                <ep-location-select id="ev-location" v-model="field.location"></ep-location-select>
                                <div v-if="isInvalid('ev-location')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['ev-location'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="number">Aantal gasten: *</label>
                                <div class="input-group" :class="isInvalid('ev-number')">
                                    <input data-hj-whitelist id="number" type="number" v-model="field.number" min="1" class="form-control" />
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">personen</span>
                                    </div>
                                </div>
                                <div v-if="isInvalid('ev-number')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['ev-number'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Aard: *</label>
                                <div :class="isInvalid('ev-aard')">
                                    <ep-aard-select ref="aardSelect" :radioButtons="true" v-model="field.aard"></ep-aard-select>
                                    <div v-if="isInvalid('ev-aard')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-aard'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Type: *</label>
                                <div :class="isInvalid('ev-type')">
                                    <ep-select ref="typeSelect" v-model="field.type" type="types" :radioButtons="true"></ep-select>
                                    <div v-if="isInvalid('ev-type')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-type'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="event_date">Evenementsdatum: *</label>
                                <div :class="isInvalid('ev-date')">
                                    <date-picker id="event_date" :use-utc="true" :bootstrap-styling="true" format="DD-MM-YYYY" class="w-100" v-model="dateSelected" :not-before="today" input-class="form-control" :lang="lang" :first-day-of-week="1"></date-picker>
                                    <div v-if="isInvalid('ev-date')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-date'].join(', ')}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="dateConstruct">Opbouw datum:</label>
                                <div :class="isInvalid('ev-dateConstruct')">
                                    <date-picker id="dateConstruct" :use-utc="true" format="DD-MM-YYYY" class="w-100" v-model="dateConstruct" :not-after="dateSelected" :not-before="today" input-class="form-control" :lang="lang" :first-day-of-week="1"></date-picker>
                                    <div v-if="isInvalid('ev-dateConstruct')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-dateConstruct'].join(', ')}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="dateDestruct">Afbouw datum:</label>
                                <div :class="isInvalid('ev-dateDestruct')">
                                    <date-picker id="dateDestruct" :use-utc="true" format="DD-MM-YYYY" class="w-100" v-model="dateDestruct" :not-before="dateSelected" input-class="form-control" :lang="lang" :first-day-of-week="1"></date-picker>
                                    <div v-if="isInvalid('ev-dateDestruct')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validationErrors['ev-dateDestruct'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="field.extra">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="target">Doel:</label>
                                <b-form-textarea id="target" v-model="field.extra.target" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('target')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['target'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="targetAudience">Doelgroep:</label>
                                <b-form-textarea id="targetAudience" v-model="field.extra.targetAudience" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('targetAudience')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['targetAudience'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="eventHistory">Evenementhistorie:</label>
                                <b-form-textarea id="eventHistory" v-model="field.extra.eventHistory" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('eventHistory')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['eventHistory'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="eventPlanning">Evenementplanning toekomst:</label>
                                <b-form-textarea id="eventPlanning" v-model="field.extra.eventPlanning" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>

                                <div v-if="isInvalid('eventPlanning')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['eventPlanning'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="field.extra">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="decisionFactors">Beslissingsfactoren:</label>
                                <b-form-textarea id="decisionFactors" v-model="field.extra.decisionFactors" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('decisionFactors')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['decisionFactors'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="decisionMaker">Beslissingsbevoegde:</label>
                                <b-form-textarea id="decisionMaker" v-model="field.extra.decisionMaker" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('decisionMaker')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['decisionMaker'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="nextStep">Vervolgstappen:</label>
                                <b-form-textarea id="nextStep" v-model="field.extra.nextStep" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('nextStep')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['nextStep'].join(', ')}}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="budgetIndication">Budgetindicatie:</label>
                                <b-form-textarea id="budgetIndication" v-model="field.extra.budgetIndication" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                <div v-if="isInvalid('budgetIndication')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['budgetIndication'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="remarks">Bijzonderheden:</label>
                                <b-form-textarea id="remarks" v-model="field.extra.remarks" placeholder="Optioneel..." rows="2" max-rows="10"></b-form-textarea>
                                <div v-if="isInvalid('remarks')" class="col-12 invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['remarks'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="!form.id">
                    <h5>Contactmoment (Optioneel)</h5>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="cm-type">Type:</label>
                                <div :class="isInvalidContactMoment('cm-type')">
                                    <ep-contact-moment-category-select :radioButtons="true" id="cm-type" v-model="contactMoment.type"></ep-contact-moment-category-select>
                                    <div v-if="isInvalidContactMoment('cm-type')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validateContactMoment['cm-type'].join(', ')}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="cm-content">Bericht:</label>
                                <div :class="isInvalidContactMoment('cm-content')">
                                    <b-form-textarea id="cm-content" v-model="contactMoment.content" placeholder="Optioneel..." rows="1" max-rows="8"></b-form-textarea>
                                    <div v-if="isInvalidContactMoment('cm-content')" class="col-12 invalid-feedback invalid-feedback-force">
                                        {{this.validateContactMoment['cm-content'].join(', ')}}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>

            <div slot="footer">
                <div v-if="!createMode" class="d-flex justify-content-between align-items-center ">
                    <div class="text-muted">
                        <small>Bepaalde velden zijn automatisch ingevuld.</small>
                    </div>
                    <div class="text-right">
                        <div class="btn-group">
                            <button class="btn btn-light" @click="update()">
                                Tussentijds opslaan
                            </button>
                            <button class="btn btn-ep" v-tooltip="!validate() ? 'Controleer de velden, op dit moment zijn nog niet alle velden juist ingevoerd' : null" :class="{'disabled': !validate()}" @click="save()">
                                Doorzetten <em class="fa fa-arrow-alt-circle-right"></em>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="createMode" class="d-flex justify-content-end align-items-center ">
                    <div class="text-right">
                        <div class="btn-group">
                            <button class="btn btn-light" @click="update()">
                                Lead opslaan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>

        <accountmanager-select ref="accountmangerModel" @selected="save"></accountmanager-select>
    </div>
</template>

<script>
    import formKeys from './../../helpers/formKeys';
    import afasCompanyInput from './../input/afasCompanyInput';
    import afasContactInput from './../input/afasContactInput';
    import epLocationSelect from './../input/epLocationSelect';
    import epSelect from './../input/epSelect';
    import epAccountmanagers from './../input/epAccountmanagersSelect';
    import epAardSelect from './../input/epAardSelect';
    import DatePicker from 'vue2-datepicker';
    import AccountmanagerSelect from "./accountmanagerSelect";
    import { EventBus } from './../../helpers/event-bus.js';
    import EpContactMomentCategorySelect from "../input/epContactMomentCategorySelect";

    export default {
        components: {
            EpContactMomentCategorySelect,
            AccountmanagerSelect,
            afasCompanyInput,
            afasContactInput,
            epLocationSelect,
            epSelect,
            epAccountmanagers,
            DatePicker,
            epAardSelect
        },
        props: {
            form: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                input: {
                    accepted: false
                },
                importantFieldsData: null,
                validationErrors: [],
                lang: {
                    'days': ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
                    'months': ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
                    'pickers': ['volgende 7 dagen', 'volgende 30 dagen', 'vorige 7 dagen', 'vorige 30 dagen'],
                    'placeholder': {
                        'date': 'Selecteer een datum',
                        'dateRange': 'Selecteer een periode'
                    }
                },
                today: this.moment(),
                dateSelected: null,
                dateConstruct: null,
                dateDestruct: null,

                field: {},
                contactMoment: {
                    type: 2,
                    content: ''
                },
                validationErrorsContactMoment: {}
            }
        },
        watch: {
            form(newVal, oldVal) {
                if(newVal.id !== oldVal.id) {
                    this.setupEventForm();
                }
            },
            'form.event'() {
                this.setupEventForm();
            },
            dateSelected(date) {
                this.field.date = date;
                if(this.dateConstruct && this.dateConstruct > this.field.date) {
                    this.dateConstruct = date;
                }
                if(this.dateDestruct && this.dateDestruct < this.field.date) {
                    this.dateDestruct = date;
                }
            },
            dateConstruct(date) {
                this.field.dateConstruct = date;
            },
            dateDestruct(date) {
                this.field.dateDestruct = date;
            },
            'field.date'(date) {
                this.dateSelected = date
            },
            'field.dateConstruct'(date) {
                this.dateConstruct = date
            },
            'field.dateDestruct'(date) {
                this.dateDestruct = date
            },
            'field.organisation'(organisation) {
                if(organisation.hasOwnProperty('type')) {

                    if(!this.field.type) {
                        let types = this.$refs.typeSelect.getResults();

                        for(let index in types) {
                            if(!types.hasOwnProperty(index)) {
                                continue;
                            }
                            let type = types[index];

                            if(
                                (type.label.toLowerCase().includes('particulier') && organisation.type === 'P')
                                || (type.label.toLowerCase().includes('zakelijk') && organisation.type === 'Z')
                            ) {
                                this.field.type = type.value;
                            }
                        }
                    }
                    if(!this.field.aard) {
                        let aardOptions = this.$refs.aardSelect.getResults();

                        for(let index in aardOptions) {
                            if(!aardOptions.hasOwnProperty(index)) {
                                continue;
                            }
                            let aard = aardOptions[index];

                            if(
                                (aard.name.toLowerCase().includes('bruiloft') && organisation.type === 'P')
                                || (aard.name.toLowerCase().includes('beurs') && organisation.type === 'Z')
                            ) {
                                this.field.aard = aard.aard_id;
                            }
                        }
                    }
                }
            }
        },
        mounted() {
            if(this.form) {
                this.setupEventForm();
            }
        },
        computed: {
            createMode() {
                return !this.form.id
            },
            importantFields() {
                this.importantFieldsData = formKeys.findRelevantData(this.form.values);
                return this.importantFieldsData;
            }
        },
        methods: {
            setupEventForm() {
                let event = Object.assign({}, this.form.event);

                if(formKeys.data.$store === null) {
                    formKeys.data.$store = this.$store;
                }
                if(!event.hasOwnProperty('date')) {

                    let date = formKeys.getDate(this.form);
                    if(date) {
                        event.date = date;
                        this.dateSelected = date;
                    } else {
                        event.date = null;
                    }
                }
                if(!event.hasOwnProperty('number')) {
                    event.number = formKeys.getNumberOfGuests(this.form);
                }
                if(!event.hasOwnProperty('status')) {
                    event.status = 'Aanvraag';
                }
                if(!event.hasOwnProperty('location')) {
                    event.location = formKeys.getLocation(this.form);
                }
                if(!event.hasOwnProperty('aard')) {
                    event.aard = formKeys.getAard(this.form);
                }
                if(!event.hasOwnProperty('bron')) {
                    event.bron = formKeys.getSource(this.form);
                }
                if(!event.hasOwnProperty('type')) {
                    event.type = formKeys.getType(this.form);
                }
                if(!event.hasOwnProperty('behuizing') && this.form.source) {
                    event.behuizing = this.form.source.ep_outdoor_id;
                }
                if(!event.hasOwnProperty('region') && this.form.source) {
                    event.region = this.form.source.ep_region_id;
                }
                if(!event.hasOwnProperty('contactInfo')) {
                    event.contactInfo = '';
                }

                let extraInfo = [
                    'target', 'targetAudience', 'eventHistory', 'eventPlanning', 'decisionFactors',
                    'decisionMaker', 'nextStep', 'budgetIndication', 'remarks'
                ];
                if(!event.hasOwnProperty('extra') || (Array.isArray(event.extra) && event.extra.length === 0)) {
                    event.extra = {};
                }
                extraInfo.forEach(function(key) {
                    if(!event.extra.hasOwnProperty(key)) {
                        event.extra[key] = '';
                    }
                });
                if(!event.hasOwnProperty('dateConstruct')) {
                    event.dateConstruct = null;
                }
                if(!event.hasOwnProperty('dateDestruct')) {
                    event.dateDestruct = null;
                }

                if(event.hasOwnProperty('date')) {
                    this.dateSelected = event.date;
                }
                if(event.hasOwnProperty('dateConstruct')) {
                    this.dateConstruct = event.dateConstruct;
                }
                if(event.hasOwnProperty('dateDestruct')) {
                    this.dateDestruct = event.dateDestruct;
                }
                this.field = event;

                this.$emit('loaded');
            },
            hideContactPersonSelect () {
                this.$refs['form-view-contact-' + this.form.id].hide();
            },
            validate(set = false) {
                let err = [];
                if(this.field.organisation === undefined || this.field.organisation === null) {
                    err['ev-organisation'] = [
                        'Kies een organisatie!'
                    ];
                }
                if(this.field.contact === undefined || this.field.conact === null) {
                    err['ev-contact'] = [
                        'Kies een contactpersoon!'
                    ];
                }
                if(this.field.location === undefined || this.field.location === null) {
                    err['ev-location'] = [
                        'Kies een Locatie!'
                    ];
                }
                if(this.field.number === undefined || this.field.number === null || this.field.number < 1) {
                    err['ev-number'] = [
                        'Schat het aantal gasten in (Meer dan 1).'
                    ];
                }
                if(this.field.location === undefined || this.field.location === null) {
                    err['ev-location'] = [
                        'Kies een Locatie!'
                    ];
                }
                if(this.field.aard === undefined || this.field.aard === null) {
                    err['ev-aard'] = [
                        'Kies een aard!'
                    ];
                }
                if(this.field.type === undefined || this.field.type === null) {
                    err['ev-type'] = [
                        'Kies een type!'
                    ];
                }
                if(this.field.date === undefined || this.field.date === null || this.field.date.length < 8) {
                    err['ev-date'] = [
                        'Vul een geldige datum in.'
                    ];
                }

                if(set) {
                    this.validationErrors = err;
                }
                return Object.keys(err).length === 0;
            },
            finish() {
                if(!this.validate(true)) {
                    return;
                }

                this.selectAccountmanager();
            },
            selectAccountmanager() {
                this.$refs.accountmangerModel.show();
            },
            update(showAlert = true) {
                if (showAlert) {
                    this.$swal.showLoading();
                    this.$swal({
                        title: 'Bezig met opslaan',
                        html: 'We versturen nu de data...',
                        allowOutsideClick: true,
                        onOpen: () => {
                            this.$swal.showLoading()
                        }
                    });
                }

                let params = Object.assign({}, this.form);
                params.event = this.field;

                let request = null;
                let mode = 'update';
                if(!this.form.id) {
                    if(params.event.contact) {
                        this.form.values.email = params.event.contact.email;
                        this.form.values.phone = params.event.contact.tel;
                    }
                    if(params.event.organisation) {
                        if(!this.form.values.email) {
                            this.form.values.email = params.event.organisation.email;
                        }
                        if(!this.form.values.phone) {
                            this.form.values.phone = params.event.organisation.tel;
                        }
                    }
                    request = axios.post('/api/v1/leads/form', params);
                    mode = 'create';
                } else {
                    request = axios.put('/api/v1/leads/form/' + this.form.id + '/update', params);
                }

                request
                    .then(response => {
                        let formSaved = response.data;
                        if (showAlert) {
                            this.$swal({
                                toast: true,
                                position: 'top',
                                type: 'success',
                                title: this.form.id ? 'Lead is bijgewerkt!' : 'Lead is opgeslagen!',
                                showConfirmButton: false,
                                timer: 2000
                            });
                        }
                        if(mode==='create' && this.contactMoment.content.length > 0) {
                            this.addContactMoment(response.data.id);
                        }
                        else if(!this.form.id) {
                            this.goTo(response.data.id);
                        }
                        this.$emit('saved', formSaved);
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });


            },
            save(accountmanager) {
                if(!this.validate(true)) {
                    return;
                }
                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met toevoegen',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                // this.field.accountmanager = accountmanager.id;
                let params = Object.assign({}, this.form);
                params.event = this.field;
                axios.put('/api/v1/leads/events/'+ this.form.id, params)
                    .then(response => {
                        let formSaved = response.data;
                        this.$swal({
                            toast: true,
                            position: 'top',
                            type: 'success',
                            title: 'Evenement is toegevoegd!',
                            text: 'Het evenement kan worden gevonden in EasyParty met reserveringsnummer: ' + formSaved.ep_nr,
                            showConfirmButton: false,
                            timer: 3000,
                        });
                        this.$emit('updated', formSaved);
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            validateContactMoment(set = false) {
                let err = [];
                if(this.contactMoment.type === undefined || this.contactMoment.type === null) {
                    err['cm-type'] = [
                        'Kies een type'
                    ];
                }
                if(this.contactMoment.content === undefined || this.contactMoment.content === null) {
                    err['cm-content'] = [
                        'Kies een contactpersoon!'
                    ];
                }
                if(set) {
                    this.validationErrorsContactMoment = err;
                }
                return Object.keys(err).length === 0;
            },
            isInvalidContactMoment(key) {
                if(this.validationErrorsContactMoment.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            },
            addContactMoment(id, goto) {
                if(!this.validateContactMoment(true)) {
                    return;
                }

                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met toevoegen van contactmoment',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                axios.post('/api/v1/leads/form/' + id + '/contactmoment', this.contactMoment)
                    .then(response => {
                        let formSaved = response.data;
                        this.$swal({
                            toast: true,
                            position: 'top',
                            type: 'success',
                            title: 'Contactmoment is toegevoegd!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        this.goTo(id);
                    })
                    .catch(error => {
                        this.$swal({
                            type: 'error',
                            showConfirmButton: false,
                            html: this.$errorMessage(error)
                        });
                    });
            },
            isInvalid(key) {
                if(this.validationErrors.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            },
            goTo(id) {
                EventBus.$emit('refresh-list');
                this.$router.replace({name: 'lead.details', params: {leadId: id}})
            }
        }
    }
</script>

<style lang="scss">
    .form-details {
        .heading {
            .title {
                font-size: 1.2em;
            }
        }
        .sub-title {
            font-weight: bolder;
            text-transform: uppercase;
            text-space: 2;
        }
        .description-textarea {
            min-height: 90px;
            height: auto;
            max-height: auto;
        }
    }
    .contactInfo {
        min-height: 105px;
    }
</style>